import React from 'react'
import Link from 'gatsby-link'
import Img from 'gatsby-image'

import WaveB from '../../images/WaveB.svg'
import Fill from '../../images/Fill.svg'
import Divider from '../../images/Divider.svg'

export const query = graphql`
  query About {
    abo: file(relativePath: {eq: "n3.jpg"}) {
    abochild: childImageSharp {
      sizes(quality: 100, maxWidth:500, toFormat: PNG, traceSVG: {color: "rgb(217, 217, 217)", threshold: 75}) {tracedSVG aspectRatio src}
    }
  },
    sachit: file(relativePath: {eq: "Sachit.jpg"}) {
    sachitchild: childImageSharp {
      sizes(quality: 100, maxWidth:500, toFormat: PNG, traceSVG: {color: "rgb(217, 217, 217)", threshold: 75}) {tracedSVG aspectRatio src}
    }
  },
    rawjesh: file(relativePath: {eq: "Rawjesh.jpg"}) {
    rawjeshchild: childImageSharp {
      sizes(quality: 100, maxWidth:500, toFormat: PNG, traceSVG: {color: "rgb(217, 217, 217)", threshold: 75}) {tracedSVG aspectRatio src}
    }
  },
    salina: file(relativePath: {eq: "Salina.jpg"}) {
    salinachild: childImageSharp {
      sizes(quality: 100, maxWidth:500, toFormat: PNG, traceSVG: {color: "rgb(217, 217, 217)", threshold: 75}) {tracedSVG aspectRatio src}
    }
  },
    rikesh: file(relativePath: {eq: "Rikesh.jpg"}) {
    rikeshchild: childImageSharp {
      sizes(quality: 100, maxWidth:500, toFormat: PNG, traceSVG: {color: "rgb(217, 217, 217)", threshold: 75}) {tracedSVG aspectRatio src}
    }
  },
    satish: file(relativePath: {eq: "Satish.jpg"}) {
    satishchild: childImageSharp {
      sizes(quality: 100, maxWidth:500, toFormat: PNG, traceSVG: {color: "rgb(217, 217, 217)", threshold: 75}) {tracedSVG aspectRatio src}
    }
  },
    sunshine: file(relativePath: {eq: "Sunshine.jpg"}) {
    sunshinechild: childImageSharp {
      sizes(quality: 100, maxWidth:500, toFormat: PNG, traceSVG: {color: "rgb(217, 217, 217)", threshold: 75}) {tracedSVG aspectRatio src}
    }
  },
    saugat: file(relativePath: {eq: "Saugat.jpg"}) {
    saugatchild: childImageSharp {
      sizes(quality: 100, maxWidth:500, toFormat: PNG, traceSVG: {color: "rgb(217, 217, 217)", threshold: 75}) {tracedSVG aspectRatio src}
    }
  },
    pratik: file(relativePath: {eq: "Pratik.jpg"}) {
    pratikchild: childImageSharp {
      sizes(quality: 100, maxWidth:500, toFormat: PNG, traceSVG: {color: "rgb(217, 217, 217)", threshold: 75}) {tracedSVG aspectRatio src}
    }
  },
    sujan: file(relativePath: {eq: "Sujan.jpg"}) {
    sujanchild: childImageSharp {
      sizes(quality: 100, maxWidth:500, toFormat: PNG, traceSVG: {color: "rgb(217, 217, 217)", threshold: 75}) {tracedSVG aspectRatio src}
    }
  },
    krishnaa: file(relativePath: {eq: "Krishnaa.jpg"}) {
    krishnaachild: childImageSharp {
      sizes(quality: 100, maxWidth:500, toFormat: PNG, traceSVG: {color: "rgb(217, 217, 217)", threshold: 75}) {tracedSVG aspectRatio src}
    }
  },
    ram: file(relativePath: {eq: "Ram.jpg"}) {
    ramchild: childImageSharp {
      sizes(quality: 100, maxWidth:500, toFormat: PNG, traceSVG: {color: "rgb(217, 217, 217)", threshold: 75}) {tracedSVG aspectRatio src}
    }
  },
}
`

const About = ({data:{abo,sachit,rawjesh,salina,rikesh,satish,sunshine,saugat,pratik,sujan,krishnaa,ram}}) => (
  <section>
    <article>
      <div className="container">
        <div>
          <div style={{display:'block'}}>
            <h1 className='smallerHone'>About</h1>
            <img src={Divider} alt="Nisadhya - Divider" style={{margin:'.75rem 0'}}/>
            <p className='biggerText'><span className='gradient'>Meet your new digital agency.</span></p>
          </div>
          <div>
            <p>Nisadhya Pvt. Ltd is a Nepal based Digital Marketing Company that provides branding and digital marketing
            solutions for national and international organizations.</p>
            <p>Our company provides an integrated and professional online business solution that is designed to help our client's
            business grow through innovation and creativity,
            which is driven through web, content, search engines, mobiles, media and online advertising.
            The teams here at Nisadhya, are highly dedicated and experienced technologists and marketers who provide world-class solution and support.</p>
            <p style={{marginBottom:'0'}}>Our development center is well equipped with ample resources to cater to the needs of the team, the projects, and the clients.
            Our team pays close attention to every minute details allowing us to provide an optimum branding and digital marketing solution for our client's business.
            While many consider the work is done once the final output is ready, we take the time to provide excellent support with a team working round the clock to review and revise our services.</p>
          </div>
        </div>
      </div>
    </article>
    <img src={WaveB} alt="Divider" style={{width:'100%', display:'block'}}/>
    <article style={{backgroundColor:'#f8f8f8'}}>
      <div className="container">
        <div style={{display:'block'}}>
          <h1 className='smallerHone'>Who We Are</h1>
          <img src={Divider} alt="Nisadhya - Divider" style={{margin:'.75rem 0'}}/>
        </div>
        <div className="full-Width" style={{alignItems:'baseline', justifyContent:'space-between'}}>
          <div className="half-Width-20">
            <Img sizes={sachit.sachitchild.sizes} alt="Sachit Man Sherchan" className="Mtt" />
            <p style={{padding:'1rem 0'}}>
              <span className='gradient' style={{fontSize:'1.25rem'}}>Sachit Man Sherchan</span>
              <img src={Fill} alt="Divider" style={{display:'block', margin:'.5rem 0'}}/>
              <span>Managing Director</span>
            </p>
          </div>
          <div className="half-Width-20">
            <Img sizes={rawjesh.rawjeshchild.sizes} alt="Rawjesh Raj Bhandari" className="Mtt" />
            <p style={{padding:'1rem 0'}}>
              <span className='gradient' style={{fontSize:'1.25rem'}}>Rawjesh Rajbhandari</span>
              <img src={Fill} alt="Divider" style={{display:'block', margin:'.5rem 0'}}/>
              <span>Head Of Creatives and Social Media Manager</span>
            </p>
          </div>
          <div className="half-Width-20">
            <Img sizes={salina.salinachild.sizes} alt="Salina Sherchan" className="Mtt" />
            <p style={{padding:'1rem 0'}}>
              <span className='gradient' style={{fontSize:'1.25rem'}}>Salina Sherchan</span>
              <img src={Fill} alt="Divider" style={{display:'block', margin:'.5rem 0'}}/>
              <span>Head Of R&D</span>
            </p>
          </div>
          <div className="half-Width-20">
            <Img sizes={rikesh.rikeshchild.sizes} alt="Rikesh Maharjan" className="Mtt" />
            <p style={{padding:'1rem 0'}}>
              <span className='gradient' style={{fontSize:'1.25rem'}}>Rikesh Maharjan</span>
              <img src={Fill} alt="Divider" style={{display:'block', margin:'.5rem 0'}}/>
              <span>Senior Web Developer</span>
            </p>
          </div>
        </div>
        <div className="full-Width" style={{alignItems:'baseline', justifyContent:'space-between'}}>
          <div className="half-Width-20">
            <Img sizes={satish.satishchild.sizes} alt="Satish Lama" className="Mtt" />
            <p style={{padding:'1rem 0'}}>
              <span className='gradient' style={{fontSize:'1.25rem'}}>Satish Lama</span>
              <img src={Fill} alt="Divider" style={{display:'block', margin:'.5rem 0'}}/>
              <span>Senior Graphic Designer</span>
            </p>
          </div>
          <div className="half-Width-20">
            <Img sizes={sunshine.sunshinechild.sizes} alt="Sunshine Rai" className="Mtt" />
            <p style={{padding:'1rem 0'}}>
              <span className='gradient' style={{fontSize:'1.25rem'}}>Sunshine Rai</span>
              <img src={Fill} alt="Divider" style={{display:'block', margin:'.5rem 0'}}/>
              <span>Content Writer</span>
            </p>
          </div>
          <div className="half-Width-20">
            <Img sizes={saugat.saugatchild.sizes} alt="Saugat Pulami" className="Mtt" />
            <p style={{padding:'1rem 0'}}>
              <span className='gradient' style={{fontSize:'1.25rem'}}>Saugat Pulami</span>
              <img src={Fill} alt="Divider" style={{display:'block', margin:'.5rem 0'}}/>
              <span>Web Developer</span>
            </p>
          </div>
          <div className="half-Width-20">
            <Img sizes={pratik.pratikchild.sizes} alt="Pratik Shrestha" className="Mtt" />
            <p style={{padding:'1rem 0'}}>
              <span className='gradient' style={{fontSize:'1.25rem'}}>Pratik Shrestha</span>
              <img src={Fill} alt="Divider" style={{display:'block', margin:'.5rem 0'}}/>
              <span>Web Developer</span>
            </p>
          </div>
        </div>
        <div className="full-Width" style={{alignItems:'baseline', justifyContent:'space-between'}}>
          <div className="half-Width-20">
            <Img sizes={sujan.sujanchild.sizes} alt="Sujan Bhandari" className="Mtt" />
            <p style={{padding:'1rem 0'}}>
              <span className='gradient' style={{fontSize:'1.25rem'}}>Sujan Bhandari</span>
              <img src={Fill} alt="Divider" style={{display:'block', margin:'.5rem 0'}}/>
              <span>Web Developer</span>
            </p>
          </div>
          <div className="half-Width-20">
            <Img sizes={krishnaa.krishnaachild.sizes} alt="Krishnaa Tandukar" className="Mtt" />
            <p style={{padding:'1rem 0'}}>
              <span className='gradient' style={{fontSize:'1.25rem'}}>Krishnaa Tandukar</span>
              <img src={Fill} alt="Divider" style={{display:'block', margin:'.5rem 0'}}/>
              <span>Creatives Head</span>
            </p>
          </div>
          <div className="half-Width-20">
            <Img sizes={ram.ramchild.sizes} alt="Krishnaa Tandukar" className="Mtt" />
            <p style={{padding:'1rem 0'}}>
              <span className='gradient' style={{fontSize:'1.25rem'}}>Ram Kumar Bomjan</span>
              <img src={Fill} alt="Divider" style={{display:'block', margin:'.5rem 0'}}/>
              <span>Graphic Designer</span>
            </p>
          </div>
          <div className="half-Width-20">
          </div>
        </div>
      </div>
    </article>
  </section>
)

export default About



// WEBPACK FOOTER //
// ./src/pages/about/index.js